<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3 class="headline mt-0">{{ $t('Setting') }}</h3>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <label class="caption" for>FACEBOOK PIXEL ID</label>
        <edit-customer-value
          v-model="shop_fb_pixel"
          :dark="true"
          placeholder="FACEBOOK PIXEL ID"
          @onEdit="saveFacbookPixelId"
        >
          <customer-item-value :value="shop_fb_pixel">{{
            shop_fb_pixel || '-'
          }}</customer-item-value>
        </edit-customer-value>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import EditCustomerValue from '@/components/view/dashboard/EditCustomerValue'
import pageConfigApi from '../../../../api/page-config'
import { mapGetters } from 'vuex'

export default {
  components: { EditCustomerValue },
  props: {},
  data() {
    return {
      shop_fb_pixel: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    selectedBot: {
      handler() {
        if (
          this.selectedBot &&
          this.selectedBot.shop_fb_pixel &&
          this.selectedBot.shop_fb_pixel != this.shop_fb_pixel
        ) {
          this.shop_fb_pixel = this.selectedBot.shop_fb_pixel
        }
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    async saveFacbookPixelId(data) {
      try {
        if (data.customer_value) {
          await pageConfigApi.postShopPixelId({
            page_id: this.selectedBot.pageid,
            shop_pixel_id: data.customer_value
          })
          data.onEdit()
        } else {
          throw 'data.customer_value not found'
        }
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'อัพเดทข้อมูลไม่สำเร็จ'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/EcommerceSetting.vue